import { useAttributesContext } from "shared/contexts/AttributesContext";
import { ContextProviderName } from "shared/contexts/types";
import { VEHICLES_OPTIONS_GENERIC_FILTER } from "shared/filterDefinitions";

import useGeneralDescriptionSchema from "./generalDescriptionSchema";
import { SchemaRelations, UseSchema } from "./types";
import { getGroupBySelectOptions } from "./utils/group-by-utils";
import {
  getAttributeMap,
  getDisplayLabelFunction,
  getFilterFunction,
  getSchemaEntryFunction,
  getSchemaForAccessorFunction,
  getSchemaFromAttributes,
} from "./utils/schema-utils";

const useVehicleOptionsSchema = (accessorsToHide: string[] = []): UseSchema => {
  const { attributes } = useAttributesContext(
    ContextProviderName.VehicleOption
  );

  const attributeMap = getAttributeMap(attributes);

  const getDisplayLabel = getDisplayLabelFunction(attributeMap);

  const getFilter = getFilterFunction(
    VEHICLES_OPTIONS_GENERIC_FILTER,
    attributeMap
  );

  const generalDescriptionSchema = useGeneralDescriptionSchema();

  const relations: SchemaRelations = {
    "/api/v1/options": generalDescriptionSchema,
  };

  const getSchemaEntry = getSchemaEntryFunction(getFilter, attributeMap);

  const schema = getSchemaFromAttributes(
    attributes,
    getSchemaEntry,
    undefined,
    relations,
    accessorsToHide
  );

  const getSchemaForAccessor = getSchemaForAccessorFunction(schema);

  const attributesForGroupBy = attributes?.filter(
    ({ ID }) => !accessorsToHide.includes(ID)
  );

  const groupBySelectOptions = getGroupBySelectOptions(attributesForGroupBy);

  return {
    schema,
    getDisplayLabel,
    attributeMap,
    groupBySelectOptions,
    attributes,
    getSchemaEntry,
    getSchemaForAccessor,
    attributeAccessors: schema.map(
      ({ accessor, filter }) => filter?.fieldName || accessor
    ),
  };
};
export default useVehicleOptionsSchema;
